import type { TupleToUnion } from 'type-fest'
import type { Action } from './actions.ts'
import type { Resource } from './resource.ts'

export const Permissions = [
  'activity:create',
  'activity:view',

  'agency:edit',
  'agency:view',
  'brand:view',

  'file:upload',

  'bid:create',
  'bid:administer',

  'cost:view',
  'cost-plus-margin:view',

  'project:view',
  'project:accept',
  'project:archive',
  'project:comment',
  'project:create',
  'project:delete',
  'project:edit',
  'project:submit',
  'project:complete',
  'project:administer',

  'offer:view',
  'offer:accept',
  'offer:decline',

  // Organizations
  'customer-organization:administer', // canAdministerCustomerOrganizations
  'own-organization:administer', // canAdministerOwnOrganization

  // Teams
  'customer-team:administer', // canAdministerCustomerTeams
  'own-organization-team:administer', // canAdministerOwnOrganizationTeams
  'own-team:administer', // canAdministerOwnTeam
  'own-team-profile:update', // canUpdateOwnTeamProfile

  // Users
  'customer-user:administer', // canAdministerCustomerUsers
  'own-organization-user:administer', // canAdministerOwnOrganizationUsers
  'own-team-user:administer', // canAdministerOwnTeamUsers

  'package:view',
  'package:administer',

  'watch:administer',
  'watch:create',
  'watch:delete',
  'watch:update',
  'watch:view',
  'watch:viewAll',

  'match:edit',
  'match:remove',
  'match:view',

  'review:administer',
  'review-feedback:update',
  'review-proposal:update',

  'internal-pricing-note:view',
] as const satisfies readonly `${Resource}:${Action}`[]

export type Permission = TupleToUnion<typeof Permissions>

export const AllPermissions = [...Permissions]
